import { z } from 'zod'
import { required } from './required'

/**
 * Campo de e-mail dos formulários da loja (login, esqueci minha senha, login sem conta do carrinho e newsletter), com a
 * mesma mensagem para ausente, vazio e inválido.
 */
export const EmailFieldSchema = z
    .string(required('Deve informar um email válido'))
    .email('Deve informar um email válido')
    .min(1, 'Deve informar um email válido')
